import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {interval, Subscription} from 'rxjs';
import {Card} from '../../../card-container/card/card';
import {StudentService} from '../../../../../shared-components/student/student.service';
import {StudentSummaryService} from '../../../student-summary.service';
import {YearService} from '../../../../../shared-components/year/year.service';
import {CardStudentProgramsServices} from './card-student-programs-services';
import {Router} from '@angular/router';

export class DisplayItem {
    name: string;
    date: string;
    service: boolean;
    program: boolean;
}

@Component({
    selector: 'app-programs-and-services-card',
    templateUrl: './programs-and-services-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./programs-and-services-card.component.css']
})
export class ProgramsAndServicesCardComponent implements OnInit, OnDestroy {

    @Input() data: any;
    subscriptions: Subscription[] = [];
    card: Card;
    displayItems: DisplayItem[] = [];
    programsAndServices: CardStudentProgramsServices[] = [];
    // Angular Material Table
    displayedColumns: string[] = ['programService', 'entry'];

    constructor(
        private studentService: StudentService,
        private router: Router,
        private studentSummaryService: StudentSummaryService,
        private yearService: YearService,
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getProgramsAndServices();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    getProgramsAndServices() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardProgramsAndServices(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.yearService.student360Year.Id).subscribe((response) => {
            if (response.ok) {
                // The following code flattens the data and removes duplicate programs
                // so it will display nicely in the table with only 2 columns
                // keep in mind that it is alphabetized by Program then Service at the Stored procedure
                this.programsAndServices = response.body;
                for (let i = 0; i < this.programsAndServices.length; i++) {
                    // Add the Program
                    this.displayItems.push({
                        name: this.programsAndServices[i].ProgramName,
                        date: '',
                        program: true,
                        service: false
                    });
                    // Add the Service
                    this.displayItems.push({
                        name: this.programsAndServices[i].ServiceName,
                        date: this.programsAndServices[i].ServiceEntryDate,
                        program: false,
                        service: true
                    });
                }
                const unqItems = [];
                this.displayItems.forEach(e => {
                    if (e.program == true) {
                        if (unqItems.includes(e.name)) {
                            this.displayItems.splice(this.displayItems.indexOf(e), 1);
                        } else {
                            unqItems.push(e.name);
                        }
                    }
                });
                // Because we are using onPush change detection
                this.updateView();
            }
        });
    }

    viewProgramsAndServices() {
        this.router.navigateByUrl('/student360/programsAndServices');
    }

    updateView() {
        this.cdr.detectChanges();
    }

}
